/** TopScreen — 起動直後のタイトル画面。
 *  Reference: docs/CLAUDE_CODE_UI_IMPLEMENTATION_BRIEF.md §4.1
 *  Phase A 仕上げ:
 *    - shared_assets/mockups/canvas_kingdom_top_screen.png をフルスクリーン背景に
 *    - タイトル / 城 / ドラゴン / TAP TO START / 歯車 は画像に焼き込み済み
 *    - 画面のどこをタップしても onStart() が走る(モバイル UX)
 */

import topHeroUrl from '../../../../shared_assets/mockups/canvas_kingdom_top_screen.png';

export interface TopScreenOptions {
  readonly onStart: () => void;
}

export class TopScreen {
  private readonly root: HTMLDivElement;
  private readonly onStart: () => void;

  constructor(root: HTMLDivElement, options: TopScreenOptions) {
    this.root = root;
    this.onStart = options.onStart;
    this.render();
  }

  private render(): void {
    this.root.innerHTML = `
      <div class="top-hero" data-action="start" role="button" tabindex="0" aria-label="Tap to start">
        <div class="top-hero-img" style="background-image: url('${topHeroUrl}');"></div>
        <button class="top-hero-gear" type="button" aria-label="Settings">⚙️</button>
        <button class="top-hero-start" type="button" data-action="start" aria-label="Tap to start"></button>
      </div>
    `;

    const hero = this.root.querySelector<HTMLElement>('.top-hero');
    hero?.addEventListener('click', () => this.onStart());
    hero?.addEventListener('keydown', (e) => {
      if (e instanceof KeyboardEvent && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        this.onStart();
      }
    });
    // Gear はクリックで簡易トーストを出す(無反応で「壊れている」と誤解されるのを防ぐ)。
    // start は発火させない。将来 Settings 画面に差し替え可能。
    this.root
      .querySelector<HTMLButtonElement>('.top-hero-gear')
      ?.addEventListener('click', (e) => {
        e.stopPropagation();
        this.showToast('Settings — Coming soon');
      });
  }

  /** 軽量トースト。TopScreen には専用 DOM が無いので動的生成し、2.4 秒で自動消去。 */
  private showToast(text: string): void {
    let toast = this.root.querySelector<HTMLElement>('.top-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'top-toast';
      this.root.appendChild(toast);
    }
    toast.textContent = text;
    toast.classList.remove('is-visible');
    void toast.offsetWidth; // reflow して再アニメ
    toast.classList.add('is-visible');
    window.setTimeout(() => toast?.classList.remove('is-visible'), 2400);
  }
}
